import api from '@/services/api';

import { type AuthUser } from '../types';

const BASE_URL = 'account';

export const getUserInfo = async () => {
  return await api.get<AuthUser>(`${BASE_URL}/user`);
};
